import { currencyFloatToString } from './currency'

export const getDepositMonthsOptions = (rent: number) => {
  const options: { label: string; id: number | string; value: string }[] = []
  for (let i = 0; i <= 3; i++) {
    if (i === 0) {
      options.push({ label: 'Sem caução', id: 0, value: currencyFloatToString(0) })
      continue
    }

    options.push({
      id: i,
      label: `0${i} ${i === 1 ? 'Mês' : 'Meses'}`,
      value: currencyFloatToString(Math.round(rent * i)),
    })
  }
  return options
}
